import { TextField, MenuItem, Box, Grid2, Container } from "@mui/material";
import { Robot, RobotDeploymentType, RobotManifest, RobotType } from "../../models/Robot";
import { TokenField } from "../TokenField";
import { useEffect, useState } from "react";
import yaml from "js-yaml";
import { RobotConfigTemplate } from "../../models/RobotConfigTemplate";
import { loadOrgRecords } from "../../api/connection";
import { set } from "ace-builds-internal/config";

export interface EditRobotProps {
  robot: Robot;
  onChange: (robot: Robot) => void;
  errors: { [key: string]: string };
}

export function Details({ robot, onChange, errors }: EditRobotProps) {
  const [manifest, setManifest] = useState<RobotManifest | undefined>();
  const [templates, setTemplates] = useState<RobotConfigTemplate[]>([]);
  useEffect(() => {
    if (!robot) return;
    const fetchTemplates = async () => {
      const manifestYaml = yaml.load(robot.yamlContent) as RobotManifest;
      setManifest(manifestYaml);
      const ts = await loadOrgRecords<RobotConfigTemplate>("robotconfigtemplates");
      const tz = ts.filter(t => t.type === manifestYaml.templateType);
      setTemplates(tz);
    };
    fetchTemplates();
  }, [robot]);
  const createInputHandler = (name: string) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      const newRobot = { ...robot, [name]: value };
      onChange(newRobot);
    };
  };
  return (
    <Container maxWidth="xl" sx={{ pt: "1rem" }}>
      <Grid2 container spacing={2}>
        <TextField label="ID" fullWidth value={robot?._id || ""} />
        <TextField
          label="Name"
          fullWidth
          value={robot?.name || ""}
          onChange={createInputHandler("name")}
          error={!!errors.name}
          helperText={errors.name}
        />
        <TextField
          label="Serial Number"
          fullWidth
          value={robot?.serialNumber || ""}
          onChange={createInputHandler("serialNumber")}
          error={!!errors.serialNumber}
          helperText={errors.serialNumber}
        />
        <TextField
          label="Type"
          value={robot?.type || ""}
          onChange={createInputHandler("type")}
          error={!!errors.type}
          helperText={errors.type}
          fullWidth
          select
        >
          <MenuItem value={RobotType.Camera}>Camera</MenuItem>
          <MenuItem value={RobotType.Drone}>Drone</MenuItem>
          <MenuItem value={RobotType.Quadruped}>Quadruped</MenuItem>
          <MenuItem value={RobotType.Camera}>Camera</MenuItem>
          <MenuItem value={RobotType.Humanoid}>Humanoid</MenuItem>
        </TextField>
        <TextField
          fullWidth
          label="Deployment Type"
          select
          value={robot?.deploymentType || RobotDeploymentType.Sim}
          onChange={createInputHandler("deploymentType")}
        >
          <MenuItem value={RobotDeploymentType.HostedSim}>Hosted Sim</MenuItem>
          <MenuItem value={RobotDeploymentType.Sim}>Sim</MenuItem>
          <MenuItem value={RobotDeploymentType.Live}>Live</MenuItem>
        </TextField>
        <TextField
          label="Version"
          fullWidth
          disabled
          value={robot?.version || ""}
        />
        <TextField
          label="Requested Version"
          fullWidth
          select
          value={manifest?.softwareVersion || ""}
          onChange={(e) => {
            const template = templates.find(t => t.version === e.target.value);
            if (!template) return;
            console.log({ template });
            onChange({ ...robot, yamlContent: template.yamlContent });
            setManifest(yaml.load(template.yamlContent) as RobotManifest);
          }}
        >
          <MenuItem value="">-- Select Version --</MenuItem>
          {templates.map((template) => (
            <MenuItem key={template._id} value={template.version}>
              {template.version}
            </MenuItem>
          ))}

        </TextField>



        {!robot?._id &&
          <TokenField
            value={robot?.token}
            onChange={(val) => onChange({ ...robot, token: val })}
            error={errors.token}
          />
        }
        {robot?._id &&
          <TextField label="Token" fullWidth value={robot?.token} disabled />
        }
        {robot?._id &&
          <TextField
            label="Robot IP"
            fullWidth
            value={robot?.robotIP || ""}
            disabled
          />
        }
      </Grid2>
    </Container>
  );
}
